import React from 'react';
import {Modal, Icon} from 'antd';
import {api, app, config} from '../../app';
import PayTemplate from '../../components/PayTemplate';

const FalseData = false;

const getParams = () => {
  return {
    indexno: app.getData('indexno'),
    account: app.getData('account'),
  };
};

/**
 * 获取我的保险列表
 * @returns {Promise<*>}
 */
export const getInsuranceList = async (params) => {
  const {flag, data, msg, total} = await app.post(api.InsuraLists, {...getParams(), ...params});
  if (flag === 1) {
    return {data, total: parseInt(total)};
  } else {
    app.alert(msg, 'error', '45%');
    return {data: [], total: 0};
  }
};

/**
 * 获取保险列表修改记录
 * @returns {Promise<*>}
 */
export const getInsuranceLog = async (params) => {
  const {flag, data, msg, total} = await app.post(api.InsuraLog, {...getParams(), ...params});
  if (flag === 1) {
    return {data, total: parseInt(total)};
  } else {
    app.alert(msg, 'error', '45%');
    return {data: [], total: 0};
  }
};

/**
 * 修改未审核通过的保险
 * @returns {Promise<*>}
 */
export const insuranceEidt = async (params) => {
  const {flag, msg} = await app.post(api.InsuraEidt, {...getParams(), ...params});
  if (flag === 1) {
    return true;
  } else {
    app.alert(msg, 'error', '45%');
    return false;
  }
};

/**
 * 保险名称选择列表
 * @returns {Promise<*>}
 */
export const insuraNameSelectLists = async () => {
  const {flag, data, msg} = await app.post(api.InsuraNameSelectLists, getParams());
  if (flag === 1) {
    return data;
  } else {
    app.alert(msg, 'error', '45%');
    return [];
  }
};

/**
 * 上传保险
 * @returns {Promise<*>}
 */
export const insuranceUpload = async (params) => {
  const {flag, msg} = await app.post(api.InsuraUpload, {...getParams(), ...params});
  if (flag === 1) {
    app.alert(msg, 'success', '45%');
    return true;
  } else {
    app.alert(msg, 'error', '45%');
    return false;
  }
};

/**
 * 获取保险订单列表
 * @returns {Promise<*>}
 */
export const getInsuranceOrderLists = async (page) => {
  const {flag, data, msg, total} = await app.post(api.InsuraOrderLists, {...getParams(), page});
  if (flag === 1) {
    return {data, total};
  } else {
    app.alert(msg, 'error', '45%');
    return {data: [], total: 0};
  }
};

/**
 * 取消保险订单
 * @returns {Promise<*>}
 */
export const insuranceOrderCancel = async (id) => {
  const {flag, msg} = await app.post(api.InsuraOrderCancel, {...getParams(), id});
  if (flag === 1) {
    return true;
  } else {
    app.alert(msg, 'error', '45%');
    return false;
  }
};

/**
 * 获取保险订单列表
 * @returns {Promise<*>}
 */
export const getInsuranceAuditLists = async (params) => {
  const {flag, data, msg, total} = await app.post(api.InsuraAuditLists, {...getParams(), ...params});
  if (flag === 1) {
    return {data, total};
  } else {
    app.alert(msg, 'error', '45%');
    return {data: [], total: 0};
  }
};

/**
 * 保险审核
 * @returns {Promise<*>}
 */
export const insuranceAudit = async (params) => {
  const {flag, msg} = await app.post(api.InsuraAudit, {...getParams(), ...params});
  if (flag === 1) {
    return true;
  } else {
    app.alert(msg, 'error', '45%');
    return Promise.reject(false);
  }
};

/**
 * 意外保险详细
 * @returns {Promise<*>}
 */
export const getInsuranceDetail = async () => {
  const {flag, data, msg} = await app.post(api.InsuraDetail, getParams());
  if (flag === 1) {
    return data;
  } else {
    app.alert(msg, 'error', '45%');
    return {};
  }
};

/**
 * 意外保险下单填写信息
 * @returns {Promise<*>}
 */
export const getInsuraOrderFormDetail = async () => {
  const {flag, data, msg} = await app.post(api.InsuraOrderFormDetail, getParams());
  if (flag === 1) {
    return data;
  } else {
    app.alert(msg, 'error', '45%');
    return false;
  }
};

/**
 * 意外保险下单
 * @returns {Promise<*>}
 */
export const insuraOrderSubmit = async (params) => {
  params.url = config.insurePay;
  const {flag, data, msg} = await app.post(api.InsuraOrderSubmit, {...getParams(), ...params});
  if (flag === 1) {
    return data;
  } else {
    app.alert(msg, 'error', '45%');
    return false;
  }
};

/**
 * 保险审核标题
 * @returns {Promise<*>}
 */
export const insuraAuditTitle = async () => {
  const {flag, data, msg} = await app.post(api.InsuraAuditTitle, getParams());
  if (flag === 1) {
    return data;
  } else {
    app.alert(msg, 'error', '45%');
    return [];
  }
};

/**
 * 意外保险支付
 * @returns {Promise<*>}
 */
export const insuraOrderPay = async (id, successCB) => {
  const {flag, data, msg} = await app.post(api.InsuraOrderPay, {...getParams(), id});
  if (flag === 1) {
    Modal.confirm({
      title: '微信扫码支付',
      centered: true,
      icon: (<Icon type="wechat" style={{color: '#00D30C'}}/>),
      width: 600,
      content: (
        <PayTemplate qrcode={config.imgUrl + data.qrcode} money={data.amount} no={data.cntr_no}
                     terminal="微信"/>),
      okText: '已支付',
      cancelText: '关闭',
      onOk: async () => {
        const res = await app.post(api.InsuraOrderState, {...getParams(), id});
        if (res.flag === 1) {
          switch (String(res.data.state)) {
            case '0':
              app.alert('暂未查到支付信息', 'warn');
              return Promise.reject(false);
            case '2':
              app.alert('支付成功', 'success');
              successCB(true);
              break;
            case '3':
              app.alert('订单支付失败', 'warn');
              successCB(true);
              break;
            case '9':
              app.alert('订单已关闭', 'warn');
              successCB(true);
              break;
            default:
              app.alert('未知错误', 'warn');
              successCB(true);
              break;
          }
        } else {
          app.alert(res.msg, 'warn');
          return Promise.reject(false);
        }
      },
      onCancel: () => {
        successCB(false);
      }
    });
    return true;
  } else {
    app.alert(msg, 'error', '45%');
    return false;
  }
};

/**
 * 保险类型
 * @returns {Promise<*>}
 */
export const insuraTypeSelectLists = async () => {
  const {flag, data, msg} = await app.post(api.InsuraTypeSelectLists, getParams());
  if (flag === 1) {
    return data;
  } else {
    app.alert(msg, 'error', '45%');
    return [];
  }
};

/**
 * 检查是否有保险
 * @returns {Promise<*>}
 */
export const checkInsurance = async () => {
  const {flag, data, msg} = await app.post(api.InsuraCheckInsurance, getParams());
  if (flag === 1) {
    return data.status;
  } else {
    app.alert(msg, 'error', '45%');
    return Promise.reject(false);
  }
};

/**
 * 检查是否上传营业执照
 * @returns {Promise<*>}
 */
export const teamIsRegister = async () => {
  const {flag, data, msg} = await app.post(api.UserTeamIsRegister, getParams());
  if (flag === 1) {
    return data;
  } else {
    app.alert(msg, 'error', '45%');
    return Promise.reject(false);
  }
};


/**
 * 获取版本更新通知
 * @returns {Promise<*>}
 */
 export const getNoticeList = async (params) => {
  const { flag, data, msg } = await app.post(api.SMnoticeList, params)
  if (flag === 1) {
      return data
  } else {
      app.alert(msg, 'error', '45%')
      return { content: '' }
  }
}


/**
 * 获取版本更新通知
 * @returns {Promise<*>}
 */
 export const getNoticeClick = async (noticeId) => {
  const { flag, data, msg } = await app.post(api.SMnoticeClick,{ ...getParams(),...noticeId})
  if (flag === 1) {
      return data
  } else {
      app.alert(msg, 'error', '45%')
      return { content: '' }
  }
}



// WEBPACK FOOTER //
// ./src/routes/insure/insure_api.jsx